export interface ComponentType {
    id: number;
    code: string;
    name: string;
    description: string;
}
